function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 505 505",
    style: {
      enableBackground: "new 0 0 505 505"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffd05b"
    },
    cx: 252.5,
    cy: 252.5,
    r: 252.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff7058"
    },
    d: "m425.8 364.7-165.2-290c-3.6-6.3-12.6-6.3-16.2 0l-165.2 290c-3.5 6.2.9 13.9 8.1 13.9h330.5c7.1 0 11.6-7.7 8-13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M254.3 108.2c-.8-1.4-2.8-1.4-3.6 0L112 351.5c-.8 1.4.2 3.1 1.8 3.1h277.3c1.6 0 2.6-1.7 1.8-3.1L254.3 108.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#395767"
    },
    d: "M252.6 324.2c-4.8 0-8.8-1.5-11.9-4.4-3.1-2.9-4.7-6.5-4.7-10.6 0-4.3 1.6-7.9 4.7-10.6 3.2-2.8 7.1-4.2 11.9-4.2s8.8 1.4 11.8 4.2c3.1 2.8 4.6 6.3 4.6 10.6s-1.5 7.9-4.6 10.7c-3 2.9-6.9 4.3-11.8 4.3zm14.8-131.5-3.5 89.1h-23.1l-3.3-89.1h29.9z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ed08b151cd6219d96e6798098c5943f3.svg";
export { ForwardRef as ReactComponent };